/**
 * The PostHog `environment` super-property for a browser host, mapped to the
 * SST stages so it matches what the server-side helper computes from
 * `SST_STAGE` / `NODE_ENV`. Shared by the app and the public help site
 * (BRE-8801), so a host is never split between dashboards.
 */
const PRODUCTION_HOSTS: ReadonlySet<string> = new Set([
  "app.brev.io",
  "api.brev.io",
  "ws.brev.io",
  "help.brev.io",
  "releases.brev.io",
]);
const STAGING_HOSTS: ReadonlySet<string> = new Set([
  "staging.brev.io",
  "api-staging.brev.io",
  "ws-staging.brev.io",
  "help-staging.brev.io",
  "releases-staging.brev.io",
]);

export function environmentFromHostname(host: string): "production" | "staging" | "development" {
  if (PRODUCTION_HOSTS.has(host)) return "production";
  if (STAGING_HOSTS.has(host)) return "staging";
  return "development";
}
